import React from "react";
import "./Header.css";
import RealMeLogo from "../../assets/images/RealMeLogo.svg";
import GroupLogo from "../../assets/images/Group.svg";

const Header = () => {
  return (
    <header className="header">
      <img
        src={RealMeLogo}
        alt="RealMe Logo"
        className="header-logo realme-logo"
      />
      <div className="vertical-divider" role="separator" />
      <img
        src={GroupLogo}
        alt="Internal Affairs logo"
        className="header-logo group-logo"
      />
    </header>
  );
};

export default Header;
